import { render } from "./CreateFeedbackPage.vue?vue&type=template&id=0304dbf2&scoped=true"
import script from "./CreateFeedbackPage.vue?vue&type=script&lang=js"
export * from "./CreateFeedbackPage.vue?vue&type=script&lang=js"

import "./CreateFeedbackPage.vue?vue&type=style&index=0&id=0304dbf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0304dbf2"]])

export default __exports__